<template>
  <el-row class="ipblacklist container_self table_parent">
    <h3>域名统计</h3>
    <el-row class="top_card_content">
      <el-col :span="5" v-loading="loadingCard">
        <el-card class="box-card third-card">
          <h2 style="height: 28px">{{ ipCount  }}</h2>
          <span>ip 总数</span>
        </el-card>
      </el-col>
      <el-col :span="5" v-loading="loadingCard">
        <el-card class="box-card first-card">
          <h2 style="height: 28px">{{ domainCount  }}</h2>
          <span>当前查询时段域名访问量</span>
        </el-card>
      </el-col>
      <el-col :span="5" v-loading="loadingCard">
        <el-card class="box-card second-card">
          <h2 style="height: 28px">{{ fraudCount}}</h2>
          <span>当前查询无效访问量</span>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline queryForm"
        style="width: 80%"
        size="mini"
      >
        <el-form-item label="IP">
          <el-input v-model="form.ip" placeholder="请输要查询ip" clearable></el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="form.startDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>

        <el-form-item style="float: right;">
          <el-button type="success"  icon="el-icon-connection" @click="downloadData(new Date().toISOString().slice(0, 10))">导出数据</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-table
      :data="domainList"
      style="width: 100%"
      v-loading="loading"
      :default-sort="{prop: 'fraudPercent', order: 'ascending'}"
      element-loading-text="查询中，请稍后"
    >
      <el-table-column  label="域名" align="center" width="250">
        <template slot-scope="scope">
            <p style="margin:0">{{ scope.row.domain }} <span v-if="scope.row.isWhite" class="heimingdan">白</span></p>
        </template>
      </el-table-column>
      <el-table-column prop="total" label="访问量" align="center"></el-table-column>
      <el-table-column prop="fraud" label="无效IP访问量" align="center" sortable></el-table-column>
      <el-table-column label="无效IP访问量/访问量" align="center" sortable :sort-method="customSortMethod">
        <template slot-scope="scope">
          <span v-if="scope.row.total">{{ ((scope.row.fraud/scope.row.total)*100).toFixed(2) }}%</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column prop="timeout" label="超时量" align="center"></el-table-column>
      <el-table-column label="超时量/访问量" align="center" sortable :sort-method="customSortMethod1">
        <template slot-scope="scope">
          <span v-if="scope.row.total">{{ ((scope.row.timeout/scope.row.total)*100).toFixed(2) }}%</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      
      <el-table-column align="center" label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="showSet(scope.row)">设置</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog title="域名白名单设置" :visible.sync="dialogFormVisible">
            <el-form :model="setWhiteList" size="mini">
                <el-form-item label="域名" :label-width="formLabelWidth">
                    <el-input v-model="setWhiteList.dm" autocomplete="off" disabled></el-input>
                </el-form-item>
                <!-- <el-form-item label="操作" :label-width="formLabelWidth">
                   <el-select v-model="setWhiteList.action" placeholder="请选相关设置" clearable>
                        <el-option :value="1" label="加入白名单"></el-option>
                        <el-option :value="2" label="移出白名单"></el-option>
                   </el-select>
                </el-form-item>
                <el-form-item label="设置" :label-width="formLabelWidth">
                   <el-select v-model="setWhiteList.type" placeholder="请选相关设置" clearable>
                        <el-option :value="0" label="白名单"></el-option>
                        <el-option :value="1" label="黑名单"></el-option>
                   </el-select>
                </el-form-item> -->
                <el-form-item label="说明" :label-width="formLabelWidth">
                    <el-input v-model="setWhiteList.description" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="来源" :label-width="formLabelWidth">
                    <el-input v-model="setWhiteList.source" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateDmStatus">确 定</el-button>
            </div>
        </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet,axiosPost } from "@/assets/ajaxFn";
import * as XLSX from 'xlsx';
export default {
  data() {
    return {
      domainList: [],
      loading: false,
      form: {
        endDate:this.getPreDate(new Date(),1),
        startDate: this.getPreDate(new Date(),1),//getPre15date(new Date())
        ip: "",
      },
      formLabelWidth:'120px',
      fraudCount: 0,
      domainCount:0,
      ipCount:0,
      loadingCard:false,
      dialogFormVisible:false,
      setWhiteList:{
        action:1,
        description:"",
        dm:"",
        source:"",
        type:0
      },
      whiteList:[],
    };
  },
  methods: {
    customSortMethod(a, b) {
      // 获取比较的值
      let valueA = a.fraud / a.total || 0;
      let valueB = b.fraud / b.total || 0;

      // 根据比较的值来进行排序
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    },
    customSortMethod1(a, b) {
      // 获取比较的值
      let valueA = a.timeout / a.total || 0;
      let valueB = b.timeout / b.total || 0;

      // 根据比较的值来进行排序
      if (valueA < valueB) {
        return -1;
      }
      if (valueA > valueB) {
        return 1;
      }
      return 0;
    },
    getPreDate(date,nums){
        let currentDate = new Date(date);
            currentDate.setDate(currentDate.getDate() - nums);
        let endDate = currentDate.toISOString().slice(0, 10);
        return endDate;
    },
   async getList(params) {
      this.loading = true;
      let dmList=[];
     await axiosGet("/api/ip_fraud_rate/domain_count", params).then((res) => {
        if (res.code == 0) {
          dmList = res.data.sort((a, b) => b.fraud - a.fraud);
          this.loading = false;
        } else {
          this.loading = false;
        }
      });

      for(var d=0;d<dmList.length;d++){
        //((scope.row.fraud/scope.row.total)*100).toFixed(2)
        dmList[d].fraudPercent=((dmList[d].fraud/dmList[d].total)*100).toFixed(2)+"%";
        for(var c=0;c<this.whiteList.length;c++){
          if(dmList[d].domain===this.whiteList[c].dm){
            dmList[d].isWhite=true;
          }
        }
      }
      this.domainList=dmList;
    },
    updateDmStatus(){
      axiosPost('/api/ip_fraud_rate/add_dm_white_black',this.setWhiteList,"JSON").then(res=>{
        if(res.code==0){
          this.$message({message:'域名状态设置成功',type:'success'});
          this.dialogFormVisible=false;
          this.getList(this.form);
          this.getWhiteList({type:0});
        }
      })
    },
    showSet(row){
      this.setWhiteList.dm=row.domain;
      this.dialogFormVisible=true;
    },
    downloadData(fileName){
      var content = [];
      if (!this.domainList.length) {
        this.$message({ message: "数据为空", type: "error" });
        return false;
      }
      content.push(["域名", "访问总量", "无效访问量", "无效IP访问量/访问量", "超时次数", "超时次数/访问次数"]);

      for (var c = 0; c < this.domainList.length; c++) {
        content.push([
          this.domainList[c].domain,
          this.domainList[c].total,
          this.domainList[c].fraud,
          ((this.domainList[c].fraud / this.domainList[c].total) * 100).toFixed(2)+"%",
          this.domainList[c].timeout,
          ((this.domainList[c].timeout / this.domainList[c].total) * 100).toFixed(2)+"%"
        ]);
      }

      const ws = XLSX.utils.aoa_to_sheet(content);
      
     

      ws['!cols'] = [{ wch: 36 }, { wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 18 }];
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName + '域名统计.xlsx';
      a.click();
    },  
    async getWhiteList(params){
     await axiosGet('/api/ip_fraud_rate/dm_white_black_list',params).then(res=>{
        if(res.code==0){
          this.whiteList=res.data.records;
        }
      })
    },
    getDomainCount() {
      this.loadingCard=true;
      axiosGet("/api/ip_fraud_rate/total_count", {
        startDate: this.form.startDate,
        endDate: this.form.endDate,
      }).then((res) => {
        if (res.code == 0) {
            this.fraudCount=res.data.fraud;
            this.domainCount=res.data.total;
            this.ipCount=res.data.ip
            this.loadingCard=false;
        }else{
          this.loadingCard=false;
        }
      });
    },
    onSubmit() {
      this.getList(this.form);
      this.getDomainCount();
      this.getWhiteList({type:0});
    },
  },
  mounted() {
    this.getList(this.form);
    this.getDomainCount();
    this.getWhiteList({type:0});
  },
};
</script>

<style>
.top_card_content .box-card {
  color: rgb(255, 255, 255);
  --va-0-stripe-color-computed: #154ec1;
  border-radius: 10px;
  margin-right: 25px;
}
.first-card {
  background: rgb(67, 163, 7) !important;
}
.second-card {
  background: rgb(21, 141, 227) !important;
}
.third-card{
  background-color: rgb(241,96,96) !important;
}
.top_card_content {
  margin-bottom: 30px;
}
</style>

<style scoped>
   .heimingdan{
        display: inline-block;
        width:20px;
        height:20px;
        background-color: white;
        color:#000;
        font-size:12px;
        margin-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/view/IpManager/domainCount.vue